import { GIT_SUCCESS_PREFIX } from "./git-success-prefix-constants";

/** A refused push or a clean-tree commit still completes, as prose that does not open with the success. */
export function softFailedGit(toolName: string, output: unknown): boolean {
  const prefix = GIT_SUCCESS_PREFIX[toolName];
  if (prefix === undefined || typeof output !== "string") {
    return false;
  }
  return !output.trimStart().startsWith(prefix);
}
